import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const TrustSignals = () => {
  return (
    <section className="relative z-10 px-6 py-20">
      <div className="mx-auto max-w-3xl rounded-2xl border border-primary/20 bg-primary/5 p-12 text-center shadow-[0_0_60px_rgba(15,185,177,0.06)]">
        <h2 className="text-3xl font-bold tracking-[-0.01em] text-foreground md:text-4xl">
          Ready to See What You've Been Missing?
        </h2>
        <p className="mt-4 font-light text-muted-foreground">
          Start your free trial today — no credit card, no commitments.
        </p>
        <Button
          asChild
          size="lg"
          className="mt-8 bg-primary px-10 text-primary-foreground shadow-[0_0_20px_rgba(15,185,177,0.25)] transition-all duration-300 hover:scale-105 hover:bg-primary/90 hover:shadow-[0_0_30px_rgba(15,185,177,0.4)]"
        >
          <Link to="/signup">
            Use Community Edition (Free) <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default TrustSignals;
